<div [formGroup]="matrixAddFormGroup">
    <div class="dropdown dropdown-inline ms-2" data-toggle="tooltip" title="Quick actions" data-placement="left"
        placement="bottom-right" ngbDropdown>
        <a class="btn primary-ebtn font-weight-bold py-3 px-6" aria-haspopup="true" aria-expanded="false"
            ngbDropdownToggle>
            {{ 'INFORMATE_HEADER.BUTTONS_TEXT.ADDNEWMETRIX' | transloco }}
        </a>

        <div class="dropdown-menu p-0 m-0 dropdown-menu-md dropdown-menu-right" ngbDropdownMenu>
            <ul class="navi navi-hover py-5">
                <li class="navi-item">
                    <a class="navi-link cursor-pointer" (click)="open(mymodal_matrix)">
                        <span class="navi-text" style="margin-left: 10px">Create New Joint Matrix</span>
                    </a>
                </li>

                <ng-template #mymodal_matrix let-modal>
                    <div class="modal-header">
                        <h4>Add Joint Matrix</h4>
                        <a class="close-icon" href="javascript:void()" ngbAutofocus (click)="modal.close('Ok click')"><i
                                class="flaticon2-cross"></i></a>
                    </div>
                    <div class="modal-body output-lable">
                        <div class="row">
                            <div class="col-md-3" style="padding: 15px">
                                <mat-label class="font-style">Name</mat-label>
                            </div>
                            <div class="col-md-9">
                                <mat-form-field class="example-full-width custom-text-field" floatLabel="never">
                                    <input type="text" matInput placeholder="New Name Here" formControlName="matrixName"
                                        name="name" matTooltip="Matrix Name is Required"
                                        [matTooltipDisabled]="matrixAddFormGroup.get('matrixName').valid"
                                           (keypress)="handleInputEvent($event, 'AllowUnderscoreHypen')"
                                           (paste)="handleInputEvent($event, 'AllowUnderscoreHypen')"
                                 />
                                </mat-form-field>
                            </div>
                        </div>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn primary-ebtn" (click)="btnCreateMatrix()"
                            aria-label="Show an example snack-bar">Ok</button>
                        <button type="button" class="btn secondary-ebtn"
                            (click)="modal.close('Ok click')">Cancel</button>
                    </div>
                </ng-template>

                <li class="navi-item">
                    <a class="navi-link cursor-pointer" (click)="openFile()">
                        <span class="navi-text" style="margin-left: 10px"> Import Joint Matrix </span>
                        <input type="file" style="display: none" />
                    </a>
                </li>
            </ul>
        </div>
    </div>
</div>